module.exports = __webpack_public_path__ + "static/img/tc3.6a9e975.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/home/imgs/tc3.png
// module id = CNw4
// module chunks = 1